import React, { useEffect, useState } from 'react';
import { css } from 'emotion';

import Text from 'shared/Text';
import { CarrotIcon } from 'shared/Icon/components/CarrotIcon';
import CreateAccountContainer from 'components/CreateAccountContainer';
import { useT } from 'client/i18n/hooks/useT';
import { ImportAgreement } from './ImportAgreement';
import { SwitchToAnchorHero } from './SwitchToAnchorHero';
import {
  Wrapper,
  OverlayWrapper,
  Overlay,
  OverlayHeader,
  OverlayHeaderSection,
  OverlayContent,
} from './styles';
import { Step } from './types';

type ImportCreateAccountProps = {
  stationId: string;
  userId: number;
  history: any;
  actions: {
    fetchTempVanitySlugFromPodcastName: () => void;
    redirectToSwitchPage: () => void;
    resetPersistedState: () => void;
  };
  onboarding: {
    rssFeed: string;
    rssFeedMetadata: {
      image: string;
      authorName: string;
    };
    vanitySlug: string;
  };
};

export const ImportCreateAccount = ({
  stationId,
  userId,
  history,
  actions: {
    fetchTempVanitySlugFromPodcastName,
    redirectToSwitchPage,
    resetPersistedState,
  },
  onboarding: { rssFeed, rssFeedMetadata, vanitySlug },
}: ImportCreateAccountProps) => {
  const t = useT();
  const [createAccountSuccess, setCreateAccountSuccess] = useState(false);

  useEffect(() => {
    fetchTempVanitySlugFromPodcastName();
  }, [fetchTempVanitySlugFromPodcastName]);

  // redirect away when the user refreshes the page or logs out
  if (!rssFeed || (createAccountSuccess && !userId)) {
    redirectToSwitchPage();
    return null;
  }

  return (
    <Wrapper>
      <SwitchToAnchorHero
        imageSrc={rssFeedMetadata.image}
        authorName={rssFeedMetadata.authorName}
      />
      <OverlayWrapper>
        <Overlay>
          <OverlayHeaderSection>
            <OverlayHeader>
              {t(
                'ImportOnboarding.ImportCreateAccount.Header',
                'Create your account',
                'Create Anchor account to import podcast'
              )}
            </OverlayHeader>
            <div
              className={css`
                text-align: center;
              `}
            >
              <Text
                size="md"
                isInline
                isBold
                color={createAccountSuccess ? '#a0a0a0' : '#15171a'}
              >
                {t('Button.Signup', 'Sign up', 'Sign up button text')}
              </Text>
              <CarrotIcon
                className={css`
                  width: 5px;
                  margin: 0 5px;
                `}
              />
              <Text
                size="md"
                isInline
                isBold
                color={createAccountSuccess ? '#15171a' : '#a0a0a0'}
              >
                {t(
                  'ImportOnboarding.ImportPodcastLabel',
                  'Import podcast',
                  'Import podcast label'
                )}
              </Text>
            </div>
          </OverlayHeaderSection>
          <OverlayContent>
            {createAccountSuccess ? (
              <ImportAgreement
                stationId={stationId}
                userId={userId}
                feedUrl={rssFeed}
                previousStep={Step.CREATE_ACCOUNT}
                history={history}
                resetPersistedState={resetPersistedState}
              />
            ) : (
              <div
                className={css`
                  max-width: 342px;
                  margin: auto;
                `}
              >
                <CreateAccountContainer
                  submitCallback={() => setCreateAccountSuccess(true)}
                  vanitySlug={vanitySlug}
                  feedUrl={rssFeed}
                />
              </div>
            )}
          </OverlayContent>
        </Overlay>
      </OverlayWrapper>
    </Wrapper>
  );
};
